import { render, staticRenderFns } from "./NewsUpload.vue?vue&type=template&id=d375bdde&scoped=true&"
import script from "./NewsUpload.vue?vue&type=script&lang=js&"
export * from "./NewsUpload.vue?vue&type=script&lang=js&"
import style0 from "./NewsUpload.vue?vue&type=style&index=0&id=d375bdde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d375bdde",
  null
  
)

export default component.exports